import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageService } from './storage.service';
import * as jwt_decode from 'jwt-decode';

import { environment } from "environments/environment";
import { lastValueFrom, Subscription } from 'rxjs';
import { AccessData, AccountItem } from '../models/accessData.model';
import { GS1LoadingService } from '@gs1france/gs1-components-library';
 let __URL_API__  = `${environment.URL_API}`; 

 @Injectable({providedIn: 'root'})
 export class TokenGS1Service implements OnDestroy {
    selectedCompany : AccountItem;
    subs: Subscription[] = [];

    constructor(private _http: HttpClient, private storageService: StorageService, private loadingService: GS1LoadingService) {}

    ngOnDestroy(): void {
        this.subs.forEach(sub => sub.unsubscribe());
      }

      async getTokenGS1Admin(): Promise<string> {
        try {
          let response = await this._http.get(__URL_API__ + 'api/GS1Token/GetTokenAdmin').toPromise();
            let tokenGS1 = response as string;

          let tokenInfoPerso = jwt_decode(tokenGS1) as string;

          localStorage.setItem('tokenGS1Admin', tokenGS1);
            return tokenGS1;
        } catch (error) {
            return '';
        }

    }
  
    private setContactField(data : AccessData) {
        this.selectedCompany.contact.email = data.contactEmail;
        this.selectedCompany.contact.gender = data.contactGender == "Monsieur" ? 860330000 : 860330001;
        this.selectedCompany.contact.firstName = data.contactFirstName;
        this.selectedCompany.contact.lastName = data.contactLastName;
        this.selectedCompany.contact.mobilePhone = data.mobilePhone;
        this.selectedCompany.contact.profesionalPhone = data.profesionalPhone;
    }

    public handleError(error: any): Promise<any> {
        console.error(error)
        this.loadingService.stopLoading('gs1-token');
        return Promise.reject(error.message || error);
    }

}